import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
  return (
    <div className="flex items-center justify-between">
      <div className="text-[14px] text-[#718096]">
        Page {currentPage} of {totalPages}
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          className="h-9 w-9 flex items-center justify-center border border-[#E2E8F0] rounded hover:bg-[#F7FAFC] disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <ChevronLeft size={16} className="text-[#4A5568]" />
        </button>
        <button
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
          className="h-9 w-9 flex items-center justify-center border border-[#E2E8F0] rounded hover:bg-[#F7FAFC] disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <ChevronRight size={16} className="text-[#4A5568]" />
        </button>
      </div>
    </div>
  );
}
